const canvas = document.getElementById("canvas");
const scene = new THREE.Scene();
const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });
const camera = new THREE.PerspectiveCamera(
  45,
  canvas.clientWidth / canvas.clientWidth,
  1,
  1000
);
const mouse = new THREE.Vector2(0.2, 0.4);

const backgroundTexture = new THREE.TextureLoader().load(
  document.getElementsByClassName("home-banner")[0].src
);

var quad = new THREE.Mesh(
  new THREE.PlaneGeometry(2, 2),
  new THREE.ShaderMaterial({
    vertexShader: document.getElementById("vertex-shader").textContent,
    fragmentShader: document.getElementById("fragment-shader").textContent,
    depthWrite: false,
    depthTest: false,
    uniforms: {
      background: {
        type: "t",
        value: backgroundTexture,
      },
      delta: {
        value: 5,
      },
      mouse: {
        value: mouse,
      },
      filter: {
        value: false,
      },
      speed: {
        value: 0.01,
      },
    },
  })
);
scene.add(quad);

function onResize() {
  renderer.setSize(canvas.clientWidth, canvas.clientHeight, false);
  camera.aspect = canvas.clientWidth / canvas.clientHeight;
  camera.updateProjectionMatrix();
}

function onMouseMove(e) {
  const x = e.clientX / (window.innerWidth * 0.5) - 1;
  const y = -1 * (e.clientY / (window.innerHeight * 0.5)) + 1;
  updateMouse(x, y);
}

function updateMouse(x, y) {
  console.log(x, y);
  TweenMax.to(mouse, 7, {
    x: x,
    y: y,
    onUpdate: function () {
      quad.material.uniforms.mouse.value = mouse;
    },
    ease: "Linear.easeInOut",
  });
}

function render(a) {
  requestAnimationFrame(render);

  quad.material.uniforms.delta.value = a;

  renderer.render(scene, camera);
}

onResize();
window.addEventListener("resize", onResize);
window.addEventListener("mousemove", debounce(onMouseMove, 200));
requestAnimationFrame(render);

window.onload = () => {
  const hideNewsletter = localStorage.getItem("hideNewsletter");

  if (!hideNewsletter) {
    const newsletterElem = document.querySelector("#newsletter-popup");

    document
      .querySelector("#newsletter-popup-close")
      .addEventListener("click", () => {
        localStorage.setItem("hideNewsletter", true);
        newsletterElem.style.display = "none";
      });

    setTimeout(() => {
      newsletterElem.style.display = "flex";
    }, 500);
  }
};
